import { render, staticRenderFns } from "./widget-chart.vue?vue&type=template&id=626c8e58&scoped=true&"
import script from "./widget-chart.vue?vue&type=script&lang=ts&"
export * from "./widget-chart.vue?vue&type=script&lang=ts&"
import style0 from "./widget-chart.vue?vue&type=style&index=0&id=626c8e58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626c8e58",
  null
  
)

export default component.exports